// ad type enum values for Tracking
export var GT12AdType;
(function (GT12AdType) {
    GT12AdType["START"] = "start";
    GT12AdType["PAUSE"] = "pause";
    GT12AdType["FAST_FORWARD"] = "fast_forward";
    GT12AdType["UNKNOWN"] = "unknown"; // shouldn't happen, but just in case
})(GT12AdType || (GT12AdType = {}));
